  <template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" :is-hidden-menu="true">
            <template #top>
                <div class="w-full flex items-center" data-id="advanced-refi">
                    <div class="flex-auto text-center">
                        <h2 class="mb-1 mt-0 md:text-4xl celebrate">You've Unlocked Your Best Loan Terms!
                            <img src="/images/celebrate.png" alt="" class="w-10 md:w-[50px] inline-block"></h2> 
                        <span class="text-gray-500">You now qualify for more cash back, lower rates, and a longer term — all with the same monthly payment.</span>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #main>


                <AppBoxContent 
                    class="my-6 p-4 lg:p-8 border border-[#2db405]"
                    style="box-shadow: 0 3px 20px 10px rgba(43, 129, 137, 0.45);"
                    width="full" 
                    rounded="lg"
                    :remove-styling="true"
                    bg-class-color="bg-white" 
                    :use-min-height="false"
                    :remove-max-width="true"
                >

                    <div class="flex">
                        <div class="check-mark mr-4">
                            <i class="fa fa-check-circle text-green-600 text-[20px]"></i>
                        </div>
                        <div class="refi-achieved-content text-[#6B7280] flex-1">
                            <h5>Your New Loan Offer</h5>
                            <div class="pt-4">
                                <FontBold class="text-4xl text-black">{{ storeData.advancedRefiMaxCashBack | formatMoney}}</FontBold>
                                <p>cash available now</p>
                            </div>

                            <SimpleDivider class="my-6" />

                            <div class="flex flex-col gap-8">
                                <h5>Your Upgrade Breakdown</h5>

                                <div>
                                    <p>Loan Term</p>
                                    <p>12 months <i class="fa-solid inline-block px-1 fa-chevron-right text-xs"></i> <FontBold class="text-black">24 months</FontBold></p>
                                </div>

                                <div>
                                    <p>Loan Amount</p>
                                    <p>{{ storeData.loanAmount | formatMoney }} <i class="fa-solid inline-block px-1 fa-chevron-right text-xs"></i> <FontBold class="text-black">{{ (storeData.payoff + storeData.advancedRefiMaxCashBack) | formatMoney }}</FontBold></p>
                                </div>

                                <p>That's <FontBold class="text-black">{{ storeData.advancedRefiMaxCashBack | formatMoney }}</FontBold> in total savings over the course of your loan.</p>
                            </div>
                        </div>
                    </div>

                </AppBoxContent>
                

                <div class="action-buttons text-center mt-12">
                    <div>
                        <LinkButton 
                            class="mb-2" 
                            href="#" 
                            @click.prevent="next()"
                            type="orange">Activate My New Loan</LinkButton>
                    </div>
                    <div>
                        <LinkButton 
                            :href="storeData.portalUrl" 
                            type="grey">Return to Portal</LinkButton>
                    </div>
                </div>

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppBoxContent from '../../../../components/AppBoxContent.vue';
import FontBold from '../components/FontBold.vue';
import SimpleDivider from '../components/SimpleDivider.vue';
import LinkButton from '../components/LinkButton.vue';
import { RefinanceStepMixin } from './../mixins/RefinanceStepMixin';
import { RefinanceFiltersMixin } from './../mixins/RefinanceFiltersMixin';
export default {
    name: 'RefinanceAchieved',
    mixins: [RefinanceStepMixin, RefinanceFiltersMixin],
    components: {
        AppBoxContent,
        FontBold,
        SimpleDivider,
        LinkButton,
    },

    data() {
        return {
        }
    },

    mounted() {
        this.$nextTick(() => {
            const header = document.querySelector('.app-header');
            const body = document.querySelector('.app-body');
            if (header && body) {
                body.style.height = `calc(100vh - ${header.offsetHeight}px)`;
            }
        });
    }
}
</script>
